import { useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import type { AuthUser } from "../app-home/_objects_home";
import { AuthContext } from "../auth-context";
import { RequestContext } from "../request-context";
import { requestPost } from "../utils/network";
import ActionButton from "../widget/action-button";
import ButtonsGroup from "../widget/buttons-group";
import FormValidating from "../widget/form-validating";
import { Modes } from "../widget/io-abstract";
import IOString from "../widget/io-string";
import Panel from "../widget/panel";
import "./page-login.css";

export default function PageLogin() {
  const authContext = useContext(AuthContext)!;
  const requestContext = useContext(RequestContext)!;
  const navigate = useNavigate();
  const params = useParams();
  const [state, setState] = useState<{ username?: string }>({ username: "" });
  const [isError, setError] = useState(false);

  const getRedirectTarget = () => {
    let redirect = params["*"];
    if (!redirect) {
      return "/";
    }

    if (!redirect.startsWith("/")) {
      redirect = "/" + redirect;
    }

    // Remove leading /login
    redirect = redirect.replace(/^(\/login)+/, "");

    return redirect;
  };

  const doLogin = (formData: FormData): void => {
    setState({ username: formData.get("username") as string | undefined });
    setError(false);

    requestContext
      .fetchJSONAndMessage<AuthUser>(
        "Looking for profile information...",
        requestPost("/api/auth/login", formData)
      )
      .then((userInfo) => {
        if (!userInfo) {
          // 404
          authContext.setAuthenticatedData(null);
          setError(true);
          return;
        }

        authContext.setAuthenticatedData(userInfo);
        navigate(getRedirectTarget(), { replace: true });
      })
      .catch(() => setError(true));
  };

  return (
    <>
      <h1>
        <img src="/static/img/header.jpg" alt="Cryptomedic" />
      </h1>
      <div style={{ height: "2em" }} />
      <Panel fixed label="Login" testid="login_panel">
        <FormValidating action={doLogin}>
          <IOString
            name="username"
            mode={Modes.input}
            value={state.username}
            required
          />
          <IOString
            name="password"
            mode={Modes.input}
            value=""
            required
            htmlProps={{ type: "password" }}
          />
          <hr />
          {isError && (
            <>
              <div className="alert alert-danger">Login failed.</div>
              <div className="alert alert-info">
                If you didn't connect over the last 18 months, your account is
                locked. Please contact the system administrator to unlock your
                account.
              </div>
              <hr />
            </>
          )}
          <ButtonsGroup align="center">
            <ActionButton action="Authenticate" type="submit" style="Confirm" />
          </ButtonsGroup>
        </FormValidating>
      </Panel>

      <div style={{ height: "10em" }} />
      <Panel
        header="AVERTISSEMENT : ACCÈS STRICTEMENT RÉSERVÉ ET CONFIDENTIEL"
        headerStyle="Warning"
        fixed
      >
        <div>
          Les informations contenues dans la base Cryptomedic sont couvertes par
          le secret médical et sont strictement confidentielles. L'accès est
          exclusivement réservé aux membres de l'équipe médicale dûment
          autorisés et concernés par ce programme.
          <br />
          <a href="/static/mentions.html" target="_blank">
            Mentions légales
          </a>
        </div>
      </Panel>
    </>
  );
}
